
<template>
  <div class="client form" :class="{ valid: valid, invalid: !valid }">
    <Hider :initiallyVisible=true>
      <template v-slot:label>Client<span> {{ valid ? "✓" : "❎" }}</span></template>
      <p class="location" v-if="cli.location">{{ cli.location.lat }}, {{ cli.location.lon }}</p>
      <p>
        <input v-model="cli.nom" placeholder="nom">
        <input v-model="cli.numero" placeholder="numero" inputmode="numeric" pattern="[0-9]+">
      </p>
      <p>
        <input class="long" v-model="cli.rue" placeholder="adresse">
      </p>
      <p>
        <vue-select placeholder="ville" :options="villes" :reduce="ville => ville.nom" v-model="cli.ville"></vue-select>
      </p>
      <p>
        <input class="long" v-model="cli.commentaire" placeholder="commentaire?">
      </p>
      <vue-select placeholder="chercher" :options="clients" @input="maybeFill">autofill</vue-select>
    </Hider>
  </div>
</template>
<script>

import _ from 'lodash'
import { villes } from '@/models/model.js'
import * as client from '@/models/client.js'
import { getGeolocation } from '@/lib/geoloc.js'
import { getClients } from '@/lib/databases.js'
import Hider from '@/components/base/Hider.vue'

let updateGeolocation = _.throttle(function (self) {
    if (self.cli.location !== "") {
        let cli = self.cli
        let lieu = client.lieu(cli)
        let set = (ok, coords, json) => {
            if (ok) {
                self.cli.location = coords;
                console.log('cli location set to', coords)
            } else {
                self.cli.location = coords;
                console.log('no location found', json)
            }
        }
        getGeolocation(lieu, set)
    }
}, 1500)

export default {
    components: { Hider },
    watch: { lieu () {
        if (this.rue !== "" && this.ville !== "") { updateGeolocation(this) }
      }
    },
    computed: {
        lieu () { return client.lieu(this.cli) },
        valid () { return client.valid(this.cli) },
    },
    updated () {
        let { nom, rue, ville, numero, commentaire, location } = this.cli;
        this.$nextTick(() => this.$emit('setClient', { nom, rue, ville, numero, commentaire, location }));
    },
    mounted () {
        let { customers } = this.$db
        let setLabeled = clients => this.clients = clients.map(client.labeler)
        getClients(customers, setLabeled)
    },
    methods: {
        numeros () {
            return this.clients.map(c => c.client.numero);
        },
        maybeFill (e) {
            if (e) { this.doFill(e.client); }
            else { this.zero()}
        },
        zero () {
            let cfg = {
              icon: 'trash',
              duration: 2000,
            };
            this.$toasted.show(`resetting (previously ${this.nom})`, cfg);
            Object.assign(this.cli, client.empty());
        },
        doFill (o) {
            let cfg = {
              icon: 'star',
              duration: 3000,
            };
            this.$toasted.show(`using: ${o.nom}`, cfg);
            Object.assign(this.cli, o);
        },
    },
    data () {
        return {
            cli: client.empty(),
            clients: [],
            villes: villes
        };
    },
}

</script>

<style>

.client.form {
    padding: 8px;
    border: thin solid #71d571;
    background-color: #d5ffd5;
}

.client input {
border-radius: 4px;
border: none;
margin: 4px 0;
padding-left: 8px;
height: 1.8em;
}

.client input.long {
}

.client button.short {
    width: 100%;
    height: 20px;
    padding: 0;
    margin: 0;
    font-size: 6pt;
}

.client p {
}

.client.form.invalid {
  border: thin solid lightpink;
  background-color: pink
}

.btn img {
    opacity: 60%;
}

.btn:hover img {
    opacity: 100%;
}

.location:before {
content: 'gps | '
}

</style>
